import React from 'react';
import {Link} from "../link/link";
import {SeeAllFooterButton} from "./see-all-footer-button";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ACTION_TYPES} from "../../consts";
import classNames from "classnames";

class SeeAllFooterWidgetProps extends BaseProps {
  buttonLabel: String;
  linkModel: BaseLinkModel;
  routeProps: Object;
  isRtl: Boolean;
  onClick: Function;
  noFollow: Boolean;
  source: String;
  shouldSendAnalyticsEvent: Boolean;
  className: String;
}

export const SeeAllFooterWidget = ({
                                     buttonLabel,
                                     isRtl,
                                     linkModel,
                                     routeProps,
                                     onClick,
                                     noFollow,
                                     controller,
                                     source,
                                     shouldSendAnalyticsEvent,
                                     className,
                                   }: SeeAllFooterWidgetProps) => {
  const {state, domUtils} = controller;
  const {appState: {settings}, currentLinkModel} = state;
  const {isWidget, bootstrapSettings: {blockInnerLinks}} = settings;

  const shouldRenderSeeAll: Boolean = !isWidget || !blockInnerLinks;

  const seeAllButtonProps = {
    buttonLabel: buttonLabel,
    isRtl: isRtl
  }

  const sendAnalyticsEvent = () => {
    controller.action(ACTION_TYPES.onSeeAllClick, {
      source,
      currentLinkModel
    });
  }

  const linkProps = {
    className: classNames('see-all-footer', className),
    model: linkModel,
    routeProps,
    shouldScrollToTop: true,
    onClick: () => {
      shouldSendAnalyticsEvent && sendAnalyticsEvent();
      domUtils.scrollToTop();

      return onClick ? onClick() : true;
    },
    noFollow
  }

  return (
    shouldRenderSeeAll ? <Link {...linkProps}>
      <SeeAllFooterButton {...seeAllButtonProps} />
    </Link> : null
  )
};
